/**
 * 文件相关的方法
 *
 */

/**
 * 通过url下载文件
 * @param {String} url
 * @param {String} name
 */
export function downloadWithBlob(url, name) {
  fetch(url).then((res) =>
    res.blob().then((blob) => {
      const a = document.createElement('a')
      const url = window.URL.createObjectURL(blob)
      const filename = name
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    }),
  )
}

/**
 * 根据文件名获取文件显示icon
 * @param {String} fileName
 * @return {String} antVueIconType
 */
export function getIconToFileName(fileName) {
  // 获取后缀
  const ext = fileName?.substr(fileName.lastIndexOf('.') + 1)
  let antVueIconType = 'file'
  if (
    // 图片
    ['bmp', 'tiff', 'tif', 'png', 'gif', 'jpeg', 'jpg', 'mng', 'xpm', 'WebP'].includes(ext)
  ) {
    antVueIconType = 'file-image'
  } else if (
    // 表格
    ['xls', 'xlsx', 'xlw', 'xlt'].includes(ext)
  ) {
    antVueIconType = 'file-excel'
  } else if (
    // pdf
    ['pdf'].includes(ext)
  ) {
    antVueIconType = 'file-pdf'
  } else if (
    // ppt
    ['pot', 'pps', 'ppt', 'pptx'].includes(ext)
  ) {
    antVueIconType = 'file-ppt'
  } else if (
    // text
    ['txt'].includes(ext)
  ) {
    antVueIconType = 'file-text'
  } else if (
    // 压缩文件
    ['zip'].includes(ext)
  ) {
    antVueIconType = 'file-zip'
  } else if (
    // word
    ['doc', 'docx'].includes(ext)
  ) {
    antVueIconType = 'file-word'
  }
  return antVueIconType
}

/**
 * 将文件size转换为K、M、G、T
 * @param {Number} size
 */
export function getfilesize(size) {
  if (!size) {
    return ''
  }

  const num = 1024.0 // byte

  if (size < num) {
    return `${size}B`
  }
  if (size < Math.pow(num, 2)) {
    return `${(size / num).toFixed(2)}K`
  } // kb
  if (size < Math.pow(num, 3)) {
    return `${(size / Math.pow(num, 2)).toFixed(2)}M`
  } // M
  if (size < Math.pow(num, 4)) {
    return `${(size / Math.pow(num, 3)).toFixed(2)}G`
  } // G
  return `${(size / Math.pow(num, 4)).toFixed(2)}T` // T
}

/**
 * 图片转换方法
 * @param {String} dataurl
 * @param filename
 */
// @example
// if (this.IEVersion() !== -1) {
//     file = this.blobToFile(this.dataURLtoBlob(data))
//     } else {
//     file = this.dataURLtoFile(data)
//     }
// 高版本浏览器 //
export const dataURLtoFile = (dataurl, filename = 'file') => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.?);/)[1]
  const suffix = mime.split('/')[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], `${filename}.${{ suffix }}`, { type: mime })
}
// export const dataURLtoBlob = (dataurl, fileName = 'file') => {
//   const arr = dataurl.split(',')
//   const mime = arr[0].match(/:(.?);/)[1]
//   // const suffix = mime.split('/')[1]
//   const bstr = atob(arr[1])
//   let n = bstr.length
//   const u8arr = new Uint8Array(n)
//   while (n--) {
//     u8arr[n] = bstr.charCodeAt(n)
//   }
//   this.fileType = mime.split('/')[1]
//   return new Blob([u8arr], { type: mime })
// }
export const dataURLtoBlob = (dataurl) => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}
// 将blob转换成file
export const blobToFile = (theBlob, fileName = 'file') => {
  theBlob.lastModifiedDate = new Date()
  theBlob.name = fileName
  theBlob.filename = fileName + this.fileType
  return theBlob
}

export const IEVersion = () => {
  const userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  const isIE = userAgent.includes('compatible') && userAgent.includes('MSIE') // 判断是否IE<11浏览器
  const isEdge = userAgent.includes('Edge') && !isIE // 判断是否IE的Edge浏览器
  const isIE11 = userAgent.includes('Trident') && userAgent.includes('rv:11.0')
  if (isIE) {
    const reIE = new RegExp('MSIE (d+.d+);')
    reIE.test(userAgent)
    const fIEVersion = parseFloat(RegExp.$1)
    if (fIEVersion === 7) {
      return 7
    } else if (fIEVersion === 8) {
      return 8
    } else if (fIEVersion === 9) {
      return 9
    } else if (fIEVersion === 10) {
      return 10
    } else {
      return 6 // IE版本<=7
    }
  } else if (isEdge) {
    return 'edge' // edge
  } else if (isIE11) {
    return 11 // IE11
  } else {
    return -1 // 不是ie浏览器
  }
}

/**
 * 格式化文件大小
 * @param value 字节长度
 */
export function renderFileSize(value) {
  if (!value) {
    return '0 Bytes'
  }
  const unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let index = 0
  const srcsize = parseFloat(value)
  index = Math.floor(Math.log(srcsize) / Math.log(1024))
  let size = srcsize / Math.pow(1024, index)
  //  保留的小数位数
  size = size.toFixed(2)
  return size + unitArr[index]
}

/**
 * 文件获取base64
 * @param{File} file 文件对象
 * @return{Promise}
 */
export function getBase64ToFile(file) {
  return new Promise(function (resolve) {
    const reader = new FileReader()
    reader.onload = function (e) {
      resolve(e.target.result.split(',')[1])
    }
    reader.readAsDataURL(file)
  })
}
